import { render } from "./AnnotationTool.vue?vue&type=template&id=20497644&scoped=true"
import script from "./AnnotationTool.vue?vue&type=script&lang=js"
export * from "./AnnotationTool.vue?vue&type=script&lang=js"

import "./AnnotationTool.vue?vue&type=style&index=0&id=20497644&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20497644"]])

export default __exports__